const E2E_PREFIX = 'main';

export default E2E_PREFIX;
